import { render, staticRenderFns } from "./LinhaDeAdiantamentoResumo.vue?vue&type=template&id=dd497392&scoped=true"
import script from "./LinhaDeAdiantamentoResumo.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaDeAdiantamentoResumo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaDeAdiantamentoResumo.vue?vue&type=style&index=0&id=dd497392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd497392",
  null
  
)

export default component.exports